/** @var jQuery */
var VirtualNavigation           = null;
var VirtualNavigationNav        = null;
var VirtualNavigationItemsGroup = null;
var VirtualNavigationItem       = null;

(function ($) {
    /**
     * Hlavní třída pro práci s mobilním menu.
     * @param {jQuery}                 selector        Selektor reálné navigace.
     * @param {jQuery}                 togglerSelector Selektor elementu rozbalující navigaci.
     * @param {VirtualNavigationNav[]} navigations     Pole navigací, které mají být zahrnuty
     *                                                 do mobilního menu.
     * @constructor
     */
    VirtualNavigation = function (selector, togglerSelector, navigations) {
        this.selector        = selector;
        this.togglerSelector = togglerSelector;
        this.navigations     = navigations;

        this.onVisibleChange = [];

        /**
         * Selektor <body>.
         * @type {jQuery}
         */
        this.bodySelector = $(document.body);

        /**
         * Příznak, zda právě dochází ke zobrazení / skrytí navigace.
         * @type {boolean}
         */
        this.toggleLock = false;
    };

    /** Třída, kterou přidáme navigaci v případě, že bude rozbalená. */
    VirtualNavigation.CLASS_ACTIVE = "active";

    /**
     * Inicializuje mobilní menu.
     */
    VirtualNavigation.prototype.initialize = function () {
        // Projdeme navigace...
        var navsLastIndex = (this.navigations.length - 1);

        for (var iNav = navsLastIndex; iNav >= 0; iNav--) {
            // ...inicializujeme...
            this.navigations[iNav].initialize();

            // ...a vložíme jejich potomky do mobilního menu.
            var childrenLastIndex = (this.navigations[iNav].children.length - 1);

            for (var iChild = childrenLastIndex; iChild >= 0; iChild--) {
                this.selector.prepend(this.navigations[iNav].children[iChild].getBuiltSelector());
            }
        }

        // Navěsíme callbacky na eventy.
        this.togglerSelector.on("click", (this.toggleVisible).bind(this));
    };

    /**
     * Zobrazí / skryje navigaci.
     */
    VirtualNavigation.prototype.toggleVisible = function () {
        // Zkontrolujeme zámek navigace.
        if (this.toggleLock) {
            return;
        }

        this.toggleLock = true;

        // Přepneme navigaci.
        var visible;

        if (!this.isVisible()) {
            visible = true;
            this.selector.addClass(VirtualNavigation.CLASS_ACTIVE);
            this.togglerSelector.addClass(VirtualNavigation.CLASS_ACTIVE);
            this.bodySelector.css({"overflow-y": "hidden"});
        } else {
            visible = false;
            this.selector.removeClass(VirtualNavigation.CLASS_ACTIVE);
            this.togglerSelector.removeClass(VirtualNavigation.CLASS_ACTIVE);
            this.bodySelector.css({"overflow-y": "scroll"});
        }

        // Zavoláme eventy.
        for (var i = 0; i < this.onVisibleChange.length; i++) {
            typeof this.onVisibleChange[i] === "function" && this.onVisibleChange[i](visible);
        }

        // Po půl vteřině odemkneme zámek.
        setTimeout((function () {
            this.toggleLock = false;
        }).bind(this), 500);
    };

    /**
     * Je navigace aktuálně zobrazena?
     * @return {boolean}
     */
    VirtualNavigation.prototype.isVisible = function () {
        return this.selector.hasClass(VirtualNavigation.CLASS_ACTIVE);
    };


    /**
     * Reprezentuje navigaci, která bude zahrnuta do mobilního menu.
     * @param {jQuery}  selector      Selektor elementu navigace.
     * @param {?string} childrenClass Třída, která bude v mobilním menu
     *                                přiřazena každému potomkovi <ul>.
     * @constructor
     */
    VirtualNavigationNav = function (selector, childrenClass) {
        this.selector      = selector;
        this.childrenClass = childrenClass;

        /**
         * Selektor skupin položek v navigaci.
         * @type {?jQuery}
         */
        this.childrenSelector = null;

        /**
         * Pole skupin položek navigace.
         * @type {VirtualNavigationItemsGroup[]}
         */
        this.children = [];
    };

    /**
     * Inicializuje navigaci.
     */
    VirtualNavigationNav.prototype.initialize = function () {
        // Načteme skupiny položek v navigaci.
        this.childrenSelector = this.selector.find("> ul");

        // Vytvoříme a inicializujeme skupiny položek.
        this.childrenSelector.each((function (index, element) {
            var child = new VirtualNavigationItemsGroup($(element), this.childrenClass);
            child.initialize();

            this.children.push(child);
        }).bind(this));
    };


    /**
     * Skupina položek v navigaci (<ul>).
     * @param {jQuery}  selector
     * @param {?string} cssClass CSS třída seznamu.
     * @constructor
     */
    VirtualNavigationItemsGroup = function (selector, cssClass) {
        this.selector = selector;
        this.cssClass = cssClass;

        /**
         * Selektor položek.
         * @type {?jQuery}
         */
        this.childrenSelector = null;

        /**
         * Položky.
         * @type {VirtualNavigationItem[]}
         */
        this.children = [];

        /**
         * Selektor určený k umístění do mobilního menu.
         * @type {?jQuery}
         */
        this.builtSelector = null;
    };

    /**
     * Inicializuje skupinu položek.
     */
    VirtualNavigationItemsGroup.prototype.initialize = function () {
        // Načteme selektor potomků.
        this.childrenSelector = this.selector.find("> li");

        // Načteme a inicializujeme potomky.
        this.childrenSelector.each((function (index, element) {
            var child = new VirtualNavigationItem($(element));
            child.initialize();

            this.children.push(child);
        }).bind(this));
    };

    /**
     * Vrátí selektor určený k umístění do mobilního menu.
     * @return {jQuery}
     */
    VirtualNavigationItemsGroup.prototype.getBuiltSelector = function () {
        if (!this.builtSelector) {
            this.builtSelector = this.buildSelector();
        }

        return this.builtSelector;
    };

    /**
     * Sestaví selektor skupiny položek.
     * @return {jQuery}
     */
    VirtualNavigationItemsGroup.prototype.buildSelector = function () {
        // Vytvoříme seznam.
        var selector = $("<ul>");

        if (this.cssClass) {
            selector.addClass(this.cssClass);
        }

        // Vložíme do seznamu potomky.
        for (var i = 0; i < this.children.length; i++) {
            selector.append(this.children[i].getBuiltSelector());
        }

        return selector;
    };

    /**
     * Reprezentuje konkrétní položku v navigaci (<li>).
     * @param {jQuery} selector
     * @constructor
     */
    VirtualNavigationItem = function (selector) {
        this.selector = selector;

        /**
         * Selektor odkazu.
         * @type {jQuery|null}
         */
        this.anchorSelector = null;

        /**
         * Selektor potomků.
         * @type {jQuery|null}
         */
        this.childrenSelector = null;

        /**
         * Popisek položky.
         * @type {?string}
         */
        this.caption = null;

        /**
         * Odkaz položky.
         * @type {?string}
         */
        this.target = null;

        /**
         * Otevřit v novém okně?
         * @type {?boolean}
         */
        this.newTab = null;

        /**
         * Potomci.
         * @type {VirtualNavigationItemsGroup[]}
         */
        this.children = [];

        /**
         * Selektor připravený ke vložení do mobilního menu.
         * @type {?jQuery}
         */
        this.builtSelector = null;

        /**
         * Příznak, zda právě probíhá rozbalování potomků položky.
         * @type {boolean}
         */
        this.expandLock = false;
    };

    /** Třída přidělovaná aktivní položce. */
    VirtualNavigationItem.CLASS_ACTIVE = "expanded";

    /**
     * Inicializace položky.
     */
    VirtualNavigationItem.prototype.initialize = function () {
        // Vytvoříme selektory pro odkaz a potomky.
        this.anchorSelector   = this.selector.find("> a");
        this.childrenSelector = this.selector.find("> ul");

        // Načteme informace o položce.
        this.caption = this.anchorSelector.text().trim();
        this.target  = this.anchorSelector.attr("href");
        this.newTab  = (this.anchorSelector.attr("target") === "_blank");

        // Načteme a inicializujeme potomky.
        this.childrenSelector.each((function (index, element) {
            var child = new VirtualNavigationItemsGroup($(element), null);
            child.initialize();

            this.children.push(child);
        }).bind(this));
    };

    /**
     * Vrátí selektor položky připravený ke vložení do mobilního menu.
     * @return {jQuery}
     */
    VirtualNavigationItem.prototype.getBuiltSelector = function () {
        if (!this.builtSelector) {
            this.builtSelector = this.buildSelector();
        }

        return this.builtSelector;
    };

    /**
     * Sestaví selektor položky.
     * @return {jQuery}
     */
    VirtualNavigationItem.prototype.buildSelector = function () {
        // Vytvoříme položku.
        var selector = $("<li>");
        selector.attr("class", this.selector.attr("class"));

        // Vytvoříme odkaz.
        var anchor = $("<a>")
            .text(this.caption)
            .attr("href", this.target);

        if (this.newTab) {
            anchor.attr("target", "_blank");
        }

        selector.append(anchor);

        // Pokud má položka potomky, vložíme ještě rozbalovací šipku.
        if (this.children.length > 0) {
            // Vytvoříme element.
            var toggleArrowIcon = $("<span>")
                .addClass("expander-icon")
                .html("&#x276F;");

            var toggleArrow = $("<span>").addClass("expander");
            toggleArrow.append(toggleArrowIcon);


            // Navěsíme callbacky k eventům.
            toggleArrow.on("click", (this.toggleExpand).bind(this));

            // Přidáme k položce.
            selector.append(toggleArrow);
        }

        // Vložíme do položky potomky.
        for (var i = 0; i < this.children.length; i++) {
            selector.append(this.children[i].getBuiltSelector());
        }

        return selector;
    };

    /**
     * Rozbalí / zabalí potomky položky menu.
     */
    VirtualNavigationItem.prototype.toggleExpand = function () {
        if (this.children.length === 0) {
            return;
        }

        this.getBuiltSelector().toggleClass(VirtualNavigationItem.CLASS_ACTIVE);
    };

    /**
     * Je položka menu rozbalena?
     * @return {boolean}
     */
    VirtualNavigationItem.prototype.isExpanded = function () {
        return this.getBuiltSelector().hasClass(VirtualNavigationItem.CLASS_ACTIVE);
    };
})(jQuery);
